<template>
  <div class="cta-outer-container">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="help-cta">
            <div class="cta-info">
              <div v-html="body_content"></div>
            </div>
            <div class="cta-image">
              <img class="lazy" :data-src="image_url" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    body_content:{ type: String, default:'' },
    image_url: { type: String, default:'' }
  },
  methods: {},
  mounted(){
    // console.log(this.body_content);
  }
};
</script>

<style lang="scss" scoped></style>
